import { jsx as _jsx } from "react/jsx-runtime";
// @ts-expect-error
import { api } from "@vidyard/embed-code";
import { useEffect, useState } from "react";
import { isNotUndefinedOrNull, TrustArcGroupId, trustArcGroupIsActive, videoTracking, windowOnLoadOrImmediate } from "../FunctionsCore";
import { renderIdentifierGeneric } from "../RenderIdentifier";
export const MediaVidyardComponent = (props) => {
    const { id } = props;
    const [playerRender, setPlayerRender] = useState(false);
    const [containerRef, setContainerRef] = useState();
    const [userHasGivenMarketingConsent, setUserHasGivenMarketingConsent] = useState(false);
    const handleContainerRef = (ref) => {
        if (isNotUndefinedOrNull(ref)) {
            setContainerRef(ref);
        }
    };
    useEffect(() => {
        if (isNotUndefinedOrNull(userHasGivenMarketingConsent) && userHasGivenMarketingConsent && isNotUndefinedOrNull(containerRef) && isNotUndefinedOrNull(id)) {
            if (!playerRender) {
                api.renderPlayer({
                    "container": containerRef,
                    "uuid": id
                });
            }
            setPlayerRender(true);
            // @ts-expect-error
            api.addReadyListener((data, player) => {
                let title = "";
                if (isNotUndefinedOrNull(player) && isNotUndefinedOrNull(player.metadata.name)) {
                    title = player.metadata.name;
                }
                player.on("playerComplete", () => {
                    videoTracking(title, "event8");
                });
                player.on("play", () => {
                    videoTracking(title, "event7");
                });
            }, id);
        }
    }, [userHasGivenMarketingConsent, containerRef]);
    useEffect(() => {
        windowOnLoadOrImmediate($(window), () => {
            try {
                if (isNotUndefinedOrNull(trustArcGroupIsActive(TrustArcGroupId.trustArcGroupTwo))) {
                    setUserHasGivenMarketingConsent(trustArcGroupIsActive(TrustArcGroupId.trustArcGroupTwo));
                }
            }
            catch (er) {
                console.log("Video-error", er);
            }
        });
    }, []);
    return (_jsx("div", { ref: handleContainerRef }));
};
const mediaVidyard = (renderableData) => renderIdentifierGeneric(MediaVidyardComponent, renderableData);
export { mediaVidyard };
